import React from 'react';
import PropTypes from 'prop-types';

const ChosenOperatorBadge = ({ name, value, iconUrl }) => {
  return (
    <div className='operators__list__chosen__bottom__operatorinfo__status__inner flex flex-ai-c flex-jc-c'>
      <div className='operators__list__chosen__bottom__operatorinfo__status__inner__title flex'>
        <img src={iconUrl} alt='' />
        <p>{name}</p>
      </div>
      <div className='operators__list__chosen__bottom__operatorinfo__status__inner__value flex'>
        <p>{value}</p>
      </div>
    </div>
  );
};

ChosenOperatorBadge.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
};

export default ChosenOperatorBadge;
